<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Admins</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Admins
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>Admins</h4>
                </div>

                <div class="card-body">
                    <!--                    <form @submit.prevent="applyFilter">-->
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="user-type">By user type</label>
                                <select id="user-type" class="form-control form-control-sm" v-model="filter.user_type">
                                    <option value="">All</option>
                                    <option value="super admin">Super admin</option>
                                    <option value="admin">Admin</option>
                                    <option value="store manager">Store manager</option>
                                </select>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="status">By status</label>
                                <select id="status" class="form-control form-control-sm" v-model="filter.status">
                                    <option value="">All</option>
                                    <option value="1">Active</option>
                                    <option value="0">Inactive</option>
                                </select>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label>&nbsp;</label>
                                <br>
                                <button type="submit" class="btn btn-sm btn-primary glow mb-1 mb-sm-0"
                                        :disabled="isLoadingFilter">
                                    Apply Filter
                                    <i class="fa fa-spinner spinner" v-if="isLoadingFilter"></i>
                                </button>
                                <!--                                    <button type="reset" @click="resetFilter" class="btn btn-sm btn-warning glow mb-1 mb-sm-0">-->
                                <!--                                        Reset Filter-->
                                <!--                                    </button>-->
                            </div>
                        </div>
                    </div>
                    <!--                    </form>-->

                    <div class="search-container">
                        <div class="row">
                            <div class="col-lg-9 col-md-8 col-sm-6 d-flex align-items-center">
                                <img src="/images/search.svg" alt="">
                                <!--                                <input id="search-term" type="text" class="table-search form-control form-control-sm"-->
                                <!--                                       placeholder="Search this table"-->
                                <!--                                       v-model="searchTerm">-->
                            </div>

                            <div class="col-lg-3 col-md-4 col-sm-6 d-flex">
                                <!--                                <download-excel type="csv" :data="admins" :export-fields="exportFields">-->
                                <!--                                    <a href="#" class="export-link"><i class="fas fa-file-csv"></i> export to csv</a>-->
                                <!--                                    | &nbsp;-->
                                <!--                                </download-excel>-->
                                <!--                                <download-excel :data="admins" :fields="exportFields">-->
                                <!--                                    <a href="#" class="export-link text-warning"><i class="fa fa-file-excel-o"></i>-->
                                <!--                                        export to excel-->
                                <!--                                    </a>-->
                                <!--                                </download-excel>-->
                            </div>
                        </div>

                    </div>

                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        @on-page-change="onPageChange"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="admins"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                             <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>
                            <span v-else-if="props.column.field === 'email'">
                                <a :href="`mailto:${props.row.email}`">{{ props.row.email }}</a>
                            </span>
                            <span v-else-if="props.column.field === 'status'" class="badge badge-glow"
                                  :class="props.row.status ? 'badge-success' : 'badge-danger'">
                                {{ props.row.status ? 'Active' : 'Inactive' }}
                            </span>
                            <span v-else-if="props.column.field === 'action'">
                                <a :href="`/admin/admins/${props.row.id}/edit`">
                                    <i class="feather icon-edit"></i> edit
                                </a> |
                                <!--                                <a href="#" @click="showAlert(props.row.id)" class="text-danger">-->
                                <!--                                    <i class="feather icon-trash-2"></i> delete-->
                                <!--                                </a>-->
                            </span>
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'

export default {
    metaInfo: {title: 'Admin'},
    props: ['admins'],
    layout: Layout,

    data: () => ({
        filter: {},
        isLoadingFilter: false,
        allAdmins: [],
        totalRecords: 0,
        serverParams: {
            page: 1,
            perPage: 10
        },
        paginationOptions: {
            enabled: true,
            mode: 'pages',
            perPage: 10,
            perPageDropdown: [5, 10, 20, 50, 100, 200],
            dropdownAllowAll: false,
        },
        columns: [
            {label: 'S/N', field: 'sn'},
            {label: 'Name', field: 'name'},
            {label: 'Email', field: 'email'},
            {label: 'Status', field: 'status', sortable: false},
            {label: 'Action', field: 'action', sortable: false},
        ],
        tableDataLoading: false,
    }),
    mounted() {
        this.allAdmins = this.admins
        // this.totalRecords = this.posts.total
    },
    methods: {
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },
        onPageChange(params) {
            this.updateParams({page: params.currentPage});
            this.paginatedData();
        },
        onPerPageChange(params) {
            this.updateParams({perPage: params.currentPerPage});
            this.paginatedData();
        },
        onSortChange(params) {
            this.serverParams.sort = {
                type: params[0].type,
                field: params[0].field,
            }
            this.paginatedData();
        },
        async paginatedData() {
            try {
                const type = this.type;
                let routeName = 'cms.blogs.paginate';
                if (type === 'research') {
                    routeName = 'cms.research-insight.paginate';
                }

                let {data: {data: {posts}}} = await axios.post(route(routeName),
                    {...this.serverParams});

                this.totalRecords = posts.total;
                this.paginationOptions.perPage = posts.per_page;
                this.post = posts.data
            } catch (e) {
                console.log(e);
            }
        },

        serialNo(props) {
            return this.serverParams.page === 1 ? props.index + 1 : (this.serverParams.perPage *
                    (this.serverParams.page - 1)) +
                props.index + 1
        },
    }
}
</script>
